import { Component, OnInit, NgModule } from '@angular/core';
import { MessageService } from '../../../framework/services/message.service';

@Component({
  standalone: false,
  selector: 'app-message-bar',
  templateUrl: './message-bar.component.html',
  styleUrls: ['./message-bar.component.css']
})
export class MessageBarComponent implements OnInit {

  message: string;
  constructor(private readonly messageService: MessageService) { }

  ngOnInit() {
    this.messageService.currentMessage.subscribe(message => {
      setTimeout(() => {
        this.message = message;
      }, 0);
    });
  }
}
@NgModule({
 
  exports: [ MessageBarComponent ],
  declarations: [ MessageBarComponent ]
})
export class MessageBarModule { }



